import {
  Dimensions,
  FlatList,
  PixelRatio,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import GiveawayIcon from "../../icons/GiveawayIcon";
import FowardFlatArrow from "../../icons/FowardFlatArrow";
import UserProfileIcon from "../../icons/UserProfileIcon";
import Comments from "../../icons/Comments";
import { Image } from "expo-image";
import Colours from "../../utils/Colours";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);

// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const dynamicTablesThumbnailHeight = Math.round((width / BASE_WIDTH) * 60);
const dynamicTablesThumbnailWidth = Math.round((width / BASE_WIDTH) * 60);
const dynamicThumbnailWidth = Math.round((width * 22) / 100);
const dynamicThumbnailHeight = Math.round((height * 10) / 100);
const dynamicCreatedForThumbnailWidth = Math.round((width * 6) / 100);
const dynamicCreatedForThumbnailHeight = Math.round((width * 6) / 100);

const AllHomeComp = ({ higherTablesLocal, topLocalCelebratories, hasCity, hasImages }) => {
  return (
    <View>
      {!hasCity && !hasImages && (
        <>
          <TouchableOpacity
            style={styles.profileDataContainer}
            //  onPress={() => setShowMyCityState(true)}
            onPress={() => setShowMyCityState(true)}
          >
            <View style={styles.profileDataSubContainer}>
              <GiveawayIcon
                color={Colours.PRIMARY}
                height={dynamicSize(25)}
                width={dynamicSize(25)}
              />
              <View style={styles.flatArrowContainer}>
                <Text style={styles.textTxt}>Setup your city </Text>
                <FowardFlatArrow color={Colours.PRIMARY} />
              </View>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.profileDataContainer}
            onPress={() => setShowUpdateProfilePage(true)}
          >
            <View style={styles.profileDataSubContainer}>
              <UserProfileIcon
                color={Colours.PRIMARY}
                height={dynamicSize(25)}
                width={dynamicSize(25)}
              />
              <View style={styles.flatArrowContainer}>
                <Text style={styles.textTxt}>Setup your profile </Text>
                <FowardFlatArrow color={Colours.PRIMARY} />
              </View>
            </View>
          </TouchableOpacity>
        </>
      )}

      {!hasCity && hasImages && (
        <>
          <TouchableOpacity
            style={styles.profileDataContainer}
            //  onPress={() => setShowMyCityState(true)}
            onPress={() => setShowMyCityState(true)}
          >
            <View style={styles.profileDataSubContainer}>
              <GiveawayIcon
                color={Colours.PRIMARY}
                height={dynamicSize(25)}
                width={dynamicSize(25)}
              />
              <View style={styles.flatArrowContainer}>
                <Text style={styles.textTxt}>Setup your city </Text>
                <FowardFlatArrow color={Colours.PRIMARY} />
              </View>
            </View>
          </TouchableOpacity>
        </>
      )}

      {hasCity && !hasImages && (
        <>
          <TouchableOpacity
            style={styles.profileDataContainer}
            onPress={() => setShowUpdateProfilePage(true)}
          >
            <View style={styles.profileDataSubContainer}>
              <UserProfileIcon
                color={Colours.PRIMARY}
                height={dynamicSize(25)}
                width={dynamicSize(25)}
              />
              <View style={styles.flatArrowContainer}>
                <Text style={styles.textTxt}>Setup your profile </Text>
                <FowardFlatArrow color={Colours.PRIMARY} />
              </View>
            </View>
          </TouchableOpacity>

          {higherTablesLocal && higherTablesLocal.length > 0 && (
            <View style={styles.bodyContainer}>
              <Text style={styles.sectionTitle}>HIGHER TABLES</Text>
              <FlatList
                data={higherTablesLocal}
                scrollEnabled={false}
                renderItem={({ item: topTables }) => (
                  <TouchableOpacity
                    key={topTables._id}
                    style={styles.tablesListContainer}
                    onPress={() => handleViewHigherTable(topTables)}
                  >
                    <Text style={styles.tableName}>{topTables?.tableCaption}</Text>
                    {topTables.totalContributions < 50000 ? (
                      <View style={styles.tableValueContainer}>
                        <Text style={styles.tableValueLabel}>Table by</Text>
                        <Text style={styles.tableValue}>{topTables?.userID?.username || " "}</Text>
                      </View>
                    ) : (
                      <View style={styles.tableValueContainer}>
                        <Text style={styles.tableValueLabel}>Table value</Text>
                        <Text style={styles.tableValue}>
                          {topTables.totalContributions.toLocaleString()}
                        </Text>
                      </View>
                    )}
                    <FlatList
                      data={
                        topTables?.images?.length > 0
                          ? topTables.images.slice(0, 4)
                          : topTables?.contributions?.[0]?.userID?.images?.length > 0
                          ? topTables.contributions[0].userID.images.slice(0, 4)
                          : topTables?.contributions
                              ?.map((c) => ({ url: c.userID?.profilePicture }))
                              .slice(0, 4) || []
                      }
                      horizontal
                      keyExtractor={(item, index) => index.toString()}
                      renderItem={({ item }) => {
                        const tablesThumbnailOriginalUrl = item?.url;

                        const tablesThumbnailUrl = getOptimizedCloudinaryUrl(
                          tablesThumbnailOriginalUrl,
                          dynamicTablesThumbnailHeight,
                          dynamicTablesThumbnailWidth
                        );

                        return (
                          <View onPress={() => {}}>
                            <Image
                              key={imageKey}
                              source={{ uri: tablesThumbnailUrl }}
                              style={[styles.picImageContr, { backgroundColor: "#d6d4d4ff" }]}
                              contentFit="cover"
                              cachePolicy="disk"
                              onError={handleImageError}
                            />
                          </View>
                        );
                      }}
                    />
                    <View style={styles.comments1}>
                      <Comments
                        height={dynamicSize(24)}
                        width={dynamicSize(24)}
                        color={Colours.PRIMARY_LIGHT}
                      />
                      <Text style={styles.comments2}>
                        {" "}
                        {topTables?.commentCount == 0 ? "" : topTables?.commentCount}
                      </Text>
                    </View>
                  </TouchableOpacity>
                )}
              />
            </View>
          )}

          {topLocalCelebratories && topLocalCelebratories.length > 0 && (
            <View style={styles.bodyContainer}>
              <View style={styles.giverHeaders}>
                {/* <Text style={styles.sectionTitle}>TOP BIRTHDAYS & CELEBRATIONS</Text> */}
                <Text style={styles.sectionTitle}>TOP CELEBRATORIES</Text>
              </View>
              <FlatList
                data={topLocalCelebratories}
                scrollEnabled={false}
                renderItem={({ item: topCelebratory }) => {
                  const thumbnailOriginalUrls =
                    topCelebratory?.images?.length > 0
                      ? topCelebratory.images[0]?.url
                      : topCelebratory?.image;

                  const createdForOriginalThumbnails = topCelebratory?.createdFor?.profilePicture;

                  const thumbnailNewUrl = getOptimizedCloudinaryUrl(
                    thumbnailOriginalUrls,
                    dynamicThumbnailHeight,
                    dynamicThumbnailWidth
                  );

                  const createdForNewThumbnail = getOptimizedCloudinaryUrl(
                    createdForOriginalThumbnails,
                    dynamicCreatedForThumbnailHeight,
                    dynamicCreatedForThumbnailWidth
                  );

                  return (
                    <TouchableOpacity
                      style={styles.itemContainer}
                      onPress={() => handleViewCelebratoryPulls(topCelebratory)}
                    >
                      <View style={styles.row}>
                        <View style={styles.flexColumn}>
                          <Text style={styles.itemTitle}>{topCelebratory.celebratoryCaption}</Text>
                          <View style={styles.tagsContainer}>
                            {topCelebratory?.selectedTags?.map((tag, index) => (
                              <View
                                key={index}
                                style={[styles.tag, { backgroundColor: getTagColor(tag) }]}
                              >
                                <Text style={styles.tagText}>{tag}</Text>
                              </View>
                            ))}
                          </View>
                          <View style={styles.creatorContainer}>
                            <Text style={styles.valueLabel}>Created for:</Text>

                            <Image
                              key={imageKey}
                              source={{ uri: createdForNewThumbnail }}
                              style={[styles.profileImage, { backgroundColor: "#d6d4d4ff" }]}
                              contentFit="cover"
                              cachePolicy="disk"
                              onError={handleImageError}
                            />

                            <Text style={styles.creatorName}>
                              {topCelebratory?.createdFor?.username}
                            </Text>
                          </View>
                        </View>
                        <Image
                          key={imageKey}
                          source={{ uri: thumbnailNewUrl }}
                          style={[styles.thumbnail, { backgroundColor: "#d6d4d4ff" }]}
                          contentFit="cover"
                          cachePolicy="disk"
                          onError={handleImageError}
                        />
                      </View>
                      <View style={styles.comments1}>
                        <Comments
                          height={dynamicSize(24)}
                          width={dynamicSize(24)}
                          color={Colours.PRIMARY_LIGHT}
                        />
                        <Text style={styles.comments2}>
                          {" "}
                          {topCelebratory?.commentCount == 0 ? "" : topCelebratory?.commentCount}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  );
                }}
                ListEmptyComponent={() => (
                  <View style={styles.emptyspaceStyle}>
                    <Image
                      source={{
                        uri: "https://cdn.pixabay.com/photo/2018/07/04/00/19/champagne-3515140_1280.jpg",
                      }}
                      style={styles.picImageContr}
                    />
                    <Image
                      source={{
                        uri: "https://cdn.pixabay.com/photo/2023/01/14/18/02/birthday-cake-7718754_960_720.jpg",
                      }}
                      style={styles.picImageContr}
                    />
                  </View>
                )}
              />
            </View>
          )}
        </>
      )}

      {hasCity && hasImages && (
        <>
          {higherTablesLocal && higherTablesLocal.length > 0 && (
            <View style={styles.bodyContainer}>
              <Text style={styles.sectionTitle}>HIGHER TABLES</Text>
              <FlatList
                data={higherTablesLocal}
                scrollEnabled={false}
                renderItem={({ item: topTables }) => (
                  <TouchableOpacity
                    key={topTables._id}
                    style={styles.tablesListContainer}
                    onPress={() => handleViewHigherTable(topTables)}
                  >
                    <Text style={styles.tableName}>{topTables?.tableCaption}</Text>
                    {topTables.totalContributions < 50000 ? (
                      <View style={styles.tableValueContainer}>
                        <Text style={styles.tableValueLabel}>Table by</Text>
                        <Text style={styles.tableValue}>
                          {topTables?.userID?.username || "Unknown"}
                        </Text>
                      </View>
                    ) : (
                      <View style={styles.tableValueContainer}>
                        <Text style={styles.tableValueLabel}>Table value</Text>
                        <Text style={styles.tableValue}>
                          {topTables.totalContributions.toLocaleString()}
                        </Text>
                      </View>
                    )}
                    <FlatList
                      data={
                        topTables?.images?.length > 0
                          ? topTables.images.slice(0, 4)
                          : topTables?.contributions?.[0]?.userID?.images?.slice(0, 4) || []
                      }
                      horizontal
                      keyExtractor={(item, index) => index.toString()}
                      renderItem={({ item }) => {
                        const tablesThumbnailOriginalUrl = item?.url;

                        const tablesThumbnailUrl = getOptimizedCloudinaryUrl(
                          tablesThumbnailOriginalUrl,
                          dynamicTablesThumbnailHeight,
                          dynamicTablesThumbnailWidth
                        );

                        return (
                          <View onPress={() => {}}>
                            <Image
                              key={imageKey}
                              source={{ uri: tablesThumbnailUrl }}
                              style={[styles.picImageContr, { backgroundColor: "#d6d4d4ff" }]}
                              contentFit="cover"
                              cachePolicy="disk"
                              onError={handleImageError}
                            />
                          </View>
                        );
                      }}
                    />
                    <View style={styles.comments1}>
                      <Comments
                        height={dynamicSize(24)}
                        width={dynamicSize(24)}
                        color={Colours.PRIMARY_LIGHT}
                      />
                      <Text style={styles.comments2}>
                        {" "}
                        {topTables?.commentCount == 0 ? "" : topTables?.commentCount}
                      </Text>
                    </View>
                  </TouchableOpacity>
                )}
              />
            </View>
          )}

          {topLocalCelebratories && topLocalCelebratories.length > 0 && (
            <View style={styles.bodyContainer}>
              <View style={styles.giverHeaders}>
                {/* <Text style={styles.sectionTitle}>TOP BIRTHDAYS & CELEBRATIONS</Text> */}
                <Text style={styles.sectionTitle}>TOP CELEBRATORIES</Text>
              </View>
              <FlatList
                data={topLocalCelebratories}
                scrollEnabled={false}
                renderItem={({ item: topCelebratory }) => {
                  const thumbnailOriginalUrls =
                    topCelebratory?.images?.length > 0
                      ? topCelebratory.images[0]?.url
                      : topCelebratory?.image;

                  const createdForOriginalThumbnails = topCelebratory?.createdFor?.profilePicture;

                  const thumbnailNewUrl = getOptimizedCloudinaryUrl(
                    thumbnailOriginalUrls,
                    dynamicThumbnailHeight,
                    dynamicThumbnailWidth
                  );

                  const createdForNewThumbnail = getOptimizedCloudinaryUrl(
                    createdForOriginalThumbnails,
                    dynamicCreatedForThumbnailHeight,
                    dynamicCreatedForThumbnailWidth
                  );

                  return (
                    <TouchableOpacity
                      style={styles.itemContainer}
                      onPress={() => handleViewCelebratoryPulls(topCelebratory)}
                    >
                      <View style={styles.row}>
                        <View style={styles.flexColumn}>
                          <Text style={styles.itemTitle}>{topCelebratory.celebratoryCaption}</Text>
                          <View style={styles.tagsContainer}>
                            {topCelebratory?.selectedTags?.map((tag, index) => (
                              <View
                                key={index}
                                style={[styles.tag, { backgroundColor: getTagColor(tag) }]}
                              >
                                <Text style={styles.tagText}>{tag}</Text>
                              </View>
                            ))}
                          </View>
                          <View style={styles.creatorContainer}>
                            <Text style={styles.valueLabel}>Created for:</Text>
                            <Image
                              key={imageKey}
                              source={{ uri: createdForNewThumbnail }}
                              style={[styles.profileImage, { backgroundColor: "#d6d4d4ff" }]}
                              contentFit="cover"
                              cachePolicy="disk"
                              onError={handleImageError}
                            />
                            <Text style={styles.creatorName}>
                              {topCelebratory?.createdFor?.username}
                            </Text>
                          </View>
                        </View>
                        <Image
                          key={imageKey}
                          source={{ uri: thumbnailNewUrl }}
                          style={[styles.thumbnail, { backgroundColor: "#d6d4d4ff" }]}
                          contentFit="cover"
                          cachePolicy="disk"
                          onError={handleImageError}
                        />
                      </View>
                      <View style={styles.comments1}>
                        <Comments
                          height={dynamicSize(24)}
                          width={dynamicSize(24)}
                          color={Colours.PRIMARY_LIGHT}
                        />
                        <Text style={styles.comments2}>
                          {" "}
                          {topCelebratory?.commentCount == 0 ? "" : topCelebratory?.commentCount}
                        </Text>
                      </View>
                    </TouchableOpacity>
                  );
                }}
              />
            </View>
          )}
        </>
      )}

      {!higherTablesLocal?.length && !topLocalCelebratories?.length && (
        <View style={styles.emptyspaceStyle}>
          <Image
            source={{
              uri: "https://cdn.pixabay.com/photo/2018/07/04/00/19/champagne-3515140_1280.jpg",
            }}
            style={styles.picImageContr}
          />
          <Image
            source={{
              uri: "https://cdn.pixabay.com/photo/2023/01/14/18/02/birthday-cake-7718754_960_720.jpg",
            }}
            style={styles.picImageContr}
          />
        </View>
      )}
    </View>
  );
};

export default AllHomeComp;

const styles = StyleSheet.create({
  emptyspaceStyle: {
    display: "flex",
    flexDirection: "row",
  },

  picImageContr: {
    height: dynamicSize(60),
    width: dynamicSize(60),
    borderRadius: dynamicSize(15),
    marginRight: dynamicSpacing(10),
    marginTop: dynamicSpacing(5),
  },

  profileDataContainer: {
    display: "flex",
    backgroundColor: "white",
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },

  selectedTable: {
    padding: dynamicSpacing(10),
    borderWidth: 1,
    borderColor: Colours.PRIMARY,
    backgroundColor: Colours.PRIMARY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSize(18),
    color: "#FFFFFF",
  },
  unselectedTable: {
    padding: dynamicSpacing(10),
    borderWidth: 1,
    // borderColor: Colours.PRIMARY,
    borderColor: Colours.DARKLIGHTGRAY,
    borderRadius: dynamicSize(50),
    paddingHorizontal: dynamicSize(18),
    //color: Colours.PRIMARY,
    color: Colours.DARKLIGHTGRAY,
  },

  profileDataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: dynamicSize(280),
    //width: '100%',
  },
  comments1: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: dynamicSpacing(5),
    //  color: Colours.DARKLIGHTGRAY,
  },
  comments2: {
    fontSize: dynamicFontSize(13),
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Regular",
  },

  textTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },

  bodyContainer: {
    marginVertical: 10,
    padding: 15,
    backgroundColor: "white",
    borderRadius: 15,
  },

  sectionTitle: {
    // fontSize: 12,
    fontSize: dynamicFontSize(12),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    marginBottom: 10,
  },
  tablesListContainer: {
    paddingBottom: 10,
    marginBottom: 10,
    gap: 5,
    borderBottomWidth: 1,
    borderBottomColor: Colours.LIGHTGRAY,
  },
  tableName: {
    color: Colours.DARKGRAY,
    // fontSize: 15,
    fontSize: dynamicFontSize(16),
    fontFamily: "Sen-Bold",
  },
  tableValueContainer: {
    flexDirection: "row",
    // justifyContent: 'space-between',
    alignItems: "center",
    width: width * 0.4, // Responsive width
    gap: dynamicSpacing(8),
  },
  tableValueLabel: {
    color: Colours.DARKLIGHTGRAY,
    // fontSize: 12,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
  },
  tableValue: {
    color: Colours.PRIMARY_LIGHT,
    fontFamily: "Sen-Bold",
    // fontSize: 16,
    fontSize: dynamicFontSize(16),
  },

  giverHeaders: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  //   modalContainer: {
  //     flex: 1,
  //     backgroundColor: Colours.LIGHTEST,
  //   },

  itemContainer: {
    paddingVertical: hp(1.5),
    borderBottomWidth: 1,
    borderBottomColor: Colours.LIGHTGRAY,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  flexColumn: {
    flex: 1,
    marginRight: wp(3),
  },
  itemTitle: {
    fontSize: dynamicFontSize(16),
    color: Colours.DARKGRAY,
    fontFamily: "Sen-Bold",
  },
  tagsContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: hp(0.5),
  },
  tag: {
    paddingHorizontal: wp(2),
    paddingVertical: hp(0.5),
    borderRadius: wp(3),
    marginRight: wp(1),
    marginBottom: wp(1),
  },
  tagText: {
    fontSize: dynamicFontSize(10),
    fontFamily: "Sen-Regular",
    color: "white",
  },
  creatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: hp(0.5),
  },
  valueLabel: {
    fontSize: dynamicFontSize(13),
    color: Colours.DARKLIGHTGRAY,
    fontFamily: "Sen-Regular",
  },
  profileImage: {
    width: wp(6),
    height: wp(6),
    borderRadius: wp(6),
    marginLeft: wp(1),
  },
  creatorName: {
    fontSize: dynamicFontSize(14),
    color: Colours.PRIMARY,
    fontFamily: "Sen-Regular",
    marginLeft: wp(1),
  },
  thumbnail: {
    width: wp(22),
    height: hp(10),
    borderRadius: wp(3),
  },
});
